import { MutationHookOptions, MutationTuple, useMutation } from '@apollo/client'
import {
  IConfirmOrderMutationParams,
  IConfirmOrderMutationResponse,
} from './types'
import confirmOrderMutation from './mutation'

/**
 * Hook declaration for the `confirmOrder` mutation.
 *
 * `no-cache` for the reason `createOrder` gives: the order it returns is the
 * same entity the poll re-reads `network-only`, and one home for it is enough.
 * @internal
 */
/*
 * ⚠️ **Do not set `errorPolicy: 'all'` or an `onError` handler here.**
 *
 * Under the default policy the mutate function *rejects*, and
 * `useOrderConfirmation` classifies every failure in its catch — a `400` is a
 * definite decline and terminal, anything else is ambiguous and polled. Either
 * of those options makes the mutation resolve with `FetchResult.errors`
 * instead, at which point the catch never runs, `result.data.confirmOrder` is
 * null, and the flow reads a client-system decline as a transport anomaly and
 * polls it to the deadline.
 */
const useConfirmOrderMutation = (
  options?: MutationHookOptions<
    IConfirmOrderMutationResponse,
    IConfirmOrderMutationParams
  >,
): MutationTuple<
  IConfirmOrderMutationResponse,
  IConfirmOrderMutationParams
> => {
  return useMutation<
    IConfirmOrderMutationResponse,
    IConfirmOrderMutationParams
  >(confirmOrderMutation, {
    fetchPolicy: 'no-cache',
    ...options,
  })
}

export default useConfirmOrderMutation
